import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const startProjectBridgeScheduleGeneration = api(async function startProjectBridgeScheduleGeneration({
    overlapId,
}) {
    if (!overlapId) return null

    return mutate(
        gql`
            mutation StartProjectBridgeScheduleGeneration($overlapId: ID!) {
                startProjectBridgeScheduleGeneration(overlapId: $overlapId)
            }
        `,
        { overlapId },
        { returns: "startProjectBridgeScheduleGeneration" }
    )
})
